import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

export interface IAccordionSettings {
  expanded?: boolean;
  isCollapsed?: boolean;
}

@Component({
  selector: 'sgt-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent implements OnInit {
  @Input() settings: IAccordionSettings;

  private defaultSettings: IAccordionSettings = {
    expanded: true,
    isCollapsed: false,
  };

  ngOnInit() {
    this.settings = {
      ...this.defaultSettings,
      ...this.settings
    };
  }

  showContent(event: Event): void {
    event.preventDefault();
    if (this.settings?.isCollapsed) {
      this.settings.expanded = !this.settings.expanded;
    }
  }
 }
